export { default as Navbar } from './Navbar'
export { default as Sidebar } from './Sidebar'
export { default as TagsView } from './TagsView'
export { default as AppMain } from './AppMain'



// WEBPACK FOOTER //
// ./src/views/layout/components/index.js